var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCtaSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1184,
    height: 337,
    viewBox: "0 0 1184 337",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5204_17433",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1184,
    height: 337
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1184,
    height: 337,
    rx: 10,
    fill: "#0D59EF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5204_17433)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9656 -3.06445C54.9656 -3.06445 66.1838 121.471 110.015 166.628C167.785 226.147 232.935 127.13 300.514 166.628C351.058 196.17 433.786 319.564 433.786 319.564",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.304 319.561C998.304 319.561 1003.8 262.259 1025.29 241.481C1053.61 214.095 1085.54 259.655 1118.67 241.481C1143.45 227.888 1184 171.112 1184 171.112",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.08 -0.491211C327.08 -0.491211 444.038 36.9076 438.986 124.6C436.591 166.165 404.299 176.767 400.361 218.123C390.215 324.672 526.789 128.312 602.77 164.187C665.124 193.627 723.844 322.037 723.844 322.037",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.037 -0.0947266C511.037 -0.0947266 605.529 199.032 683.734 163.199C716.507 148.182 719.934 103.571 752.813 88.9744C823.682 57.5125 843.13 223.702 917.712 218.125C1007.72 211.394 1080.38 -0.0947266 1080.38 -0.0947266",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.979 -111.927C516.979 -111.927 611.471 87.1998 689.676 51.3666C722.449 36.3503 725.876 -8.26097 758.755 -22.8577C829.624 -54.3195 849.072 111.87 923.654 106.293C1013.66 99.5621 1086.32 -111.927 1086.32 -111.927",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 323.521C0 323.521 52.0234 214.318 95.0794 233.969C113.123 242.204 115.009 266.669 133.111 274.674C172.128 291.928 182.836 200.789 223.897 203.847C273.45 207.538 313.455 323.521 313.455 323.521",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4563 383.891C4.4563 383.891 56.4797 274.688 99.5357 294.339C117.579 302.574 119.466 327.04 137.568 335.044C176.584 352.298 187.292 261.159 228.353 264.217C277.907 267.909 317.912 383.891 317.912 383.891",
    stroke: "white",
    strokeWidth: 4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaSvg);
export default __webpack_public_path__ + "static/media/cta-svg.f068580c4c11e2c536ef27a7f68cb086.svg";
export { ForwardRef as ReactComponent };